<template>
  <div 
    class="form-check form-check-custom form-check-solid" 
    :class="'form-check-' + tamanho" 
    :title="info" 
    style="display: inline-block; margin-bottom: 4px; cursor: pointer; text-wrap-mode: nowrap; font-size: 12px; line-height: normal;" 
    :style="{'margin-bottom': (mgbottom || mgbottom === '0') ? mgbottom + 'px' : '4px'}"
  >
    <input 
      class="form-check-input" 
      type="checkbox" 
      v-model="valor" 
      true-value="1" 
      false-value="0" 
      style="cursor: pointer;" 
      :style="{'margin-top': mgtopinput ? mgtopinput : ''}" 
      :disabled="disabled"
    />
    <label class="form-check-label" :title="label" :style="{'margin-top': '2px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'max-width': maxwidth ? maxwidth : '220px', 'cursor': 'pointer'}" @click="toggleValue">
      <span :class="{'required': required}">
        <img 
          v-if="icone" 
          :src="icone" 
          style="width: 20px; margin-right: 4px;" 
          :title="label"
        /> {{ nolabel ? "" : ((label) ? label : 'Campo Label') }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "InputCheckbox",
  data() {
    return {
      
    };
  },
  computed: {
    valor: {
      get() {
        return this.value ? this.value : this.modelValue;
      },
      set(newValue) {
        if(this.$talklogos) {
          this.$emit("input", newValue);
          this.$emit("change");
        } else {
          this.$emit("update:modelValue", newValue);
        }
      }
    }
  },
  props: [
    "modelValue", 
    "label", 
    "disabled", 
    "required", 
    "tamanho", 
    "value", 
    "icone", 
    "nolabel", 
    "mgbottom", 
    "mgtopinput",
    "maxwidth", 
    "info"
  ],
  methods: {
    toggleValue() {
      if(!this.disabled) {
        this.valor = (this.valor == "1") ? "0" : "1";
      }
    }
  }
}
</script>

<style scoped>

</style>